export const HOME_PATH = '/';
export const BRIDGE_PATH = '/';
export const TRANSACTIONS_PATH = '/transactions';
export const TRANSACTION_DETAIL_PATH = '/transactions/:id';
export const HOW_IT_WORKS_PATH = '/how-it-works';
export const FAUCET_PATH = '/faucet';
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const TOS_PATH = '/terms-of-service';
export const STATUS_PATH = '/status';
export const BEAM_PATH = '/beam';
export const LIMITS_PATH = '/limits';

/**
 * Build a URL to the transaction detail page
 */
export const transactionDetailPath = (id: string) => `/transactions/${id}`;
